import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {Translations} from "@translations";

export interface DialogData_ExportEventDialogInput extends MatDialogDataBaseInput {
	eventId: string;
	eventIdList: string[];
}

export interface DialogData_ExportEventDialogOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-export-event-dialog",
	templateUrl: "./export-event-dialog.component.html",
	styleUrls: ["./export-event-dialog.component.scss"],
	standalone: false,
})
export class ExportEventDialogComponent extends BasicMaterialDialog<
	ExportEventDialogComponent,
	DialogData_ExportEventDialogInput,
	DialogData_ExportEventDialogOutput
> {
	T = Translations;

	constructor(_injector: Injector) {
		super(_injector);
	}

	ngOnInit(): void {}
}
